module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-consent"
  }, [_c('page-header', {
    staticClass: "compressed"
  }, [(_vm.showAppDetails) ? [(_vm.app.url) ? [_vm._v("Log in to "), _c('a', {
    attrs: {
      "href": _vm.app.url,
      "_target": "blank"
    }
  }, [_vm._v(_vm._s(_vm.app.name))])] : [_vm._v("Log in to " + _vm._s(_vm.app.name))]] : (_vm.appIsLocal) ? [_vm._v("Log in to " + _vm._s(_vm.app.name))] : [_vm._v("Log in")]], 2), (_vm.showAppDetails && _vm.app.publisher) ? _c('div', {
    staticClass: "app-consent__publisher"
  }, [(_vm.logoUrl) ? _c('div', {
    staticClass: "app-consent__publisher-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": "Logo"
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "app-consent__publisher-details"
  }, [_c('div', [_vm._v(_vm._s(_vm.app.publisher.name))]), (_vm.app.publisher.url) ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.app.publisher.url
    }
  }, [_vm._v(_vm._s(_vm.app.publisher.url))])]) : _vm._e(), _c('div', {
    staticClass: "app-consent__publisher-links"
  }, [(_vm.app.publisher.privacyUrl) ? _c('small', [_c('a', {
    attrs: {
      "href": _vm.app.publisher.privacyUrl,
      "target": "_blank"
    }
  }, [_vm._v("Privacy")])]) : _vm._e(), (_vm.app.publisher.termsUrl) ? _c('small', [_c('a', {
    attrs: {
      "href": _vm.app.publisher.termsUrl,
      "target": "_blank"
    }
  }, [_vm._v("Terms")])]) : _vm._e()])])]) : _vm._e(), _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onAllow.apply(null, arguments)
      }
    }
  }, [(_vm.showAppDetails) ? _c('div', {
    staticClass: "w-login-form__app-details"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [(_vm.app.description) ? _c('p', [_vm._v(_vm._s(_vm.app.description))]) : _vm._e()]), _c('div', {
    staticClass: "w-login-form__row access"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.app.name) + " requires access to:")])])])]) : _c('div', {
    staticClass: "w-login-form__app-details"
  }, [_vm._m(0)]), _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('ul', {
    staticClass: "scope-list"
  }, _vm._l((_vm.requestedScope), function(productCode) {
    return _c('li', [_c('span', {
      staticClass: "app-icon"
    }, [_c('img', {
      attrs: {
        "src": _vm.getAppIcon(productCode)
      }
    })]), _c('span', [_vm._v("Read and write your " + _vm._s(_vm.getAppName(productCode)) + " data")])])
  }), 0)]), _vm._m(1)]), _c('div', {
    staticClass: "w-page-footer"
  }, [_c('button', {
    staticClass: "w-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onDeny.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Deny")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row access"
  }, [_c('p', [_c('strong', [_vm._v("A third-party application requires access to:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Allow")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-239200ad","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/AppConsent/AppConsent.vue
// module id = 591
// module chunks = 1